// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__v8blZ","small":"styles_small__2JQPc","medium":"styles_medium__2Ot9V","big":"styles_big__3eaX9","progress":"styles_progress__24XjS"};